import { useState } from "react";

import { useMediaQuery } from "@/hooks";
import {
  HOME_DEFAULT_VIEW,
  HOME_NARROW_QUERY,
  HOME_NARROW_VIEW,
  HOME_VIEWS,
  type HomeViewId,
} from "./home.constants";
import { useHomeSummary } from "./hooks/use-home-summary";
import type { HomeViewModel } from "./types-home";

/** ViewModel da Início: visão ativa, o papel do painel e os dados da consulta única das duas visões. */
export function useHome(): HomeViewModel {
  const { status, summary, errorMessage, reload } = useHomeSummary();
  const isNarrow = useMediaQuery(HOME_NARROW_QUERY);
  const [visaoEscolhida, setVisaoEscolhida] = useState<HomeViewId>(HOME_DEFAULT_VIEW);
  // RN07 do 1473: no mobile a Visão Geral fica escondida, qualquer que seja a escolha feita em tela larga.
  const visaoAtiva = isNarrow ? HOME_NARROW_VIEW : visaoEscolhida;

  return {
    visoes: [...HOME_VIEWS],
    visaoAtiva,
    visaoAtivaLabel: HOME_VIEWS.find((view) => view.id === visaoAtiva)?.label ?? "Tela Inicial",
    isVisaoGeral: visaoAtiva === "visao-geral",
    papelPainel: isNarrow ? "region" : "tabpanel",
    isNarrow,
    status,
    errorMessage: errorMessage ?? undefined,
    overview: summary?.overview ?? null,
    obrasEmAndamento: summary?.obrasEmAndamento ?? null,
    selecionarVisao: setVisaoEscolhida,
    tentarNovamente: reload,
  };
}
